export const env = (name: string): string | undefined => {
  const key = `REACT_APP_${name}`
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as Record<string, any>)[key] || process.env[key]
}
export const BACKEND_URL = 'BACKEND_URL'
export const QWIK_RETURN_URL = 'QWIK_RETURN_URL'
export const VALUT_RETURN_URL = 'VALUT_RETURN_URL'
export const TRAVEL_RETURN_URL = 'TRAVEL_RETURN_URL'
